module.exports = __webpack_public_path__ + "img/icon_unpin.b892e592.svg";